import ManufacturerEdit from '../components/Manufacturers/ManufacturerEdit';
import { Link } from 'react-router-dom';

export default function ManufacturerEditPage() {
  return (
    <div className="max-w-2xl mx-auto mt-8">
      <nav className="mb-6 text-sm text-gray-500">
        <Link to="/" className="hover:underline">Home</Link>
        <span className="mx-2">/</span>
        <Link to="/manufacturer/list" className="hover:underline">Manufacturers</Link>
        <span className="mx-2">/</span>
        <span className="text-gray-700 font-semibold">Edit</span>
      </nav>
      <ManufacturerEdit />
    </div>
  );
}